import { NavigationEnd, Router } from '@angular/router';
import { faBell, faChevronDown, faBars, faTimes, faSignOut } from '@fortawesome/pro-light-svg-icons';
import { Component, Input, OnInit, Output, EventEmitter, Optional, InjectionToken } from '@angular/core';
import { AuthService, IUser, EventService, IAdmin } from '@clooper/core';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  icons: any = {
    bell: faBell,
    chevron: faChevronDown,
    menu: faBars,
    close: faTimes,
    signout: faSignOut,
  }

  @Input() isOpened = false;

  @Input() user: IUser;
  @Input() admin: IAdmin;
  @Input() menuItems: any = [];
  @Input() disableToggle: boolean;
  @Input() viewType = 'user'
  @Output() toggled = new EventEmitter<boolean>();


  constructor(
    private router: Router,
    @Optional() private eventSrv: EventService,
    @Optional() private authService: AuthService) { }

  ngOnInit() {
    this.user = this.authService.getAuthorizedUser()
    this.eventSrv.observeUser.subscribe(user => {
      if(user) {
        this.user = user
      }
    })
    this.hideToggle(this.router.url)
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: any) => {
      this.hideToggle(event.url)
      this.isOpened = false;
      this.toggled.emit(this.isOpened);
    })
  }

  toggle() {
    this.isOpened = !this.isOpened;
    this.toggled.emit(this.isOpened);
  }

  hideToggle(url: string) {
    if(url.includes('properties/create')) {
      this.disableToggle = true;
    } else {
      this.disableToggle = false;
    }
  }

  logout() {
    this.authService.signout()
    this.router.navigate(['/login'])
  }

}

export const HEADER_MENU_ITEMS = new InjectionToken<any[]>('Header Menu Items', {
  providedIn: 'root',
  factory: () => [],
});
